<template>
    <div class="table_wrap"><span class="total_length">총 {{ paginationData.total }}개 </span>
    <el-table :data="utilityData"
              class="list-table"
              header-cell-class-name="list-header"
              empty-text="데이터가 없습니다."
              height="695"
    >
        <el-table-column
            class="table_no"
            type="index"
            label="No"
            width="90"
            class-name="num text-center"
            :index="tableIdx"
        >
        </el-table-column>
        <el-table-column width="" label="판매 상태" class-name="text-center">
            <template slot-scope="scope">
                <span>
                    {{returnSalesStatus(scope.row.uu_is_deal)}}
                </span>
            </template>
        </el-table-column>
        <el-table-column min-width="" label="사용 상태" class-name="text-center">
            <template slot-scope="scope">
                <span>
                    {{returnUseStatus(scope.row.u_use_end_date, scope.row.u_use_total, scope.row.uu_use_cnt)}}
                </span>
            </template>
        </el-table-column>
        <el-table-column min-width="" label="상위 카테고리" prop="parent_uc_name" class-name="text-center">
        </el-table-column>
        <el-table-column min-width="" label="하위 카테고리" prop="child_uc_name" class-name="text-center">
        </el-table-column>
        <el-table-column label="유틸리티" width="" prop="u_name" class-name="text-center">
        </el-table-column>
        <el-table-column label="컬렉션" width="" prop="c_title"  class-name="text-center">
        </el-table-column>
        <el-table-column width="" label="발행 개수" prop="selled_cnt" class-name="text-center">
        </el-table-column>
        <el-table-column width="" label="발행일" prop="created_at" class-name="text-center">
            <template slot-scope="scope">
                <span>
                {{ returnDateFormat(scope.row.created_at,'YYYY-MM-DD HH:mm') }}
            </span>
            </template>
        </el-table-column>
        <el-table-column width="" label="옵션" class-name="text-center">
          <template slot-scope="scope">
            <el-button class="com_btn ml15" @click="moveDetail(scope.row.u_idx)">상세</el-button>
          </template>
        </el-table-column>
    </el-table>
</div>
</template>

<script>

import dateMixins from "@/mixins/dateMixins";
import alertMixins from "@/mixins/alertMixins";
import commonOptions from "@/mixins/commonOptions";

export default {
name : "UtilityListDefaultLayout",
mixins: [dateMixins, alertMixins,commonOptions],
components : {
},
inject: {
        setPage: {
            default: () => {
            }
        },

        setFilter: {
            default: () => {
            }
        },
    },
provide(){
    return{

    }
},
props: {
    utilityType: '',
    utilityData: {
        default: () => {
            return []
        }
    },
    paginationData : {
        default: () => {
            return {total: 0, page: 0, size: 0,}
        }
    }
},
data(){
    return {

    }
},
beforeRouterEnter() {},
created() {
},
mounted() {
},
beforeDestroy() {
},
destroyed() {},
computed: {
},
methods: {
    returnSalesStatus(status){
        if(status === 1){
            return '판매중'
        }else{
            return '판매안함'
        }
    },
    returnDate(date = null) {
        if (!date) {
          return '';
        }
        return this.$moment(date).format('YYYY-MM-DD HH:mm')
    },
    tableIdx(index) {
        return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
    returnUseStatus(stringEndDate, totalNumberOfAvailableTimes, currentNumberOfUsesStatus){
        const endDate = new Date(stringEndDate);
        const nowDate = new Date();
        if(endDate > nowDate && currentNumberOfUsesStatus === 0 && totalNumberOfAvailableTimes > 0){
            return '사용대기'
        }
        if(endDate > nowDate && currentNumberOfUsesStatus !== 0 && currentNumberOfUsesStatus < totalNumberOfAvailableTimes && totalNumberOfAvailableTimes > 0){
            return '사용가능'
        }
        if(endDate < nowDate){
            return '기한만료'
        }
        return '기한만료'
    },
  moveDetail(idx) {
    this.$router.push(`/item/utility/${idx}`)
  }
},
watch : {}
}

</script>

<style scoped>
</style>
